import {
  Box,
  Button ,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Tab,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

const DriveButtons = (props) => {
  const { sendCommand,
          auto_tracking,
          up_left,
          up,
          up_right,
          left,
          toggle,
          right,
          down_left,
          down,
          down_right } = props;
  
  const trackingButtonStyle= {
    backgroundColor:"#dddddd",
    color:"green",
    width: "97%",
  	margin:"1%"
  }


  const trackingButtonSelectedStyle= {
    backgroundColor:"green",
    color:"white",
    width: "97%",
    margin:"1%"
  }


  const driveStyle = {
    backgroundColor:"#dddddd",
    color:"green",
    fontSize:"24pt",
    margin:"2%",
    width: "92%",
    height: "50px"
  };

  const driveSelectedStyle = {
    backgroundColor:"green",
    color:"white",
    fontSize:"24pt",
    margin:"2%",
    width: "92%",
    height: "50px"
  };


  const toggleStyle = {
    backgroundColor:"#dddddd",
    color:"green",
    fontSize:"12pt",
    margin:"2%",
    width: "92%",
    height: "50px"
  }


  const toggleSelectedStyle = {
    backgroundColor:"green",
    color:"white",
    fontSize:"12pt",
    margin:"2%",
    width: "92%",
    height: "50px"
  }


  return (
    <Grid
      container
      spacing={1}
    >
    	<Grid 
    	  item
		  lg={12}
          md={12}
          xl={12}
          xs={12}
    	>
    	  <Button 
          onClick={() => {
            sendCommand("auto_tracking", !auto_tracking);
          }}
          checked={auto_tracking}
          style={auto_tracking ?trackingButtonSelectedStyle : trackingButtonStyle} 
          variant="contained">
            Auto Tracking {auto_tracking ?"(On)":"(Off)"}
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button
          onClick={() => {
            sendCommand("up_left", !up_left);
          }}
          checked={up_left} 
          style={up_left ?driveSelectedStyle : driveStyle} 
          variant="contained">
            &#8598;
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button
          onClick={() => {
            sendCommand("up", !up);
          }}
          checked={up}
          style={up ?driveSelectedStyle : driveStyle} 
          enabled={!auto_tracking}
          variant="contained">
            &uarr;
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button 
          onClick={() => {
            sendCommand("up_right", !up_right);
          }}
          checked={up_right} 
          style={up_right ?driveSelectedStyle : driveStyle}
          variant="contained">
            &#8599;
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button
          onClick={() => {
            sendCommand("left", !left);
          }}
          checked={left} 
          style={left ?driveSelectedStyle : driveStyle} 
          variant="contained">
            &larr;
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button 
          onClick={() => {
            sendCommand("toggle", !toggle);
          }}
          checked={toggle} 
          style={toggle ?toggleSelectedStyle : toggleStyle} 
          variant="contained">
            toggle
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button 
          onClick={() => {
            sendCommand("right", !right);
          }}
          checked={right}  
          style={right ?driveSelectedStyle : driveStyle}
          variant="contained">
            &rarr;
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button
          onClick={() => {
            sendCommand("down_left", !down_left);
          }}
          checked={down_left} 
          style={down_left ?driveSelectedStyle : driveStyle}
          variant="contained">
            &#8601;
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button 
          onClick={() => {
            sendCommand("down", !down);
          }}
          checked={down}
          style={down ?driveSelectedStyle : driveStyle}
          variant="contained">
            &darr;
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={4}
          md={4}
          xl={4}
          xs={4}
    	>
    	  <Button 
          onClick={() => {
            sendCommand("down_right", !down_right);
          }}
          checked={down_right} 
          style={down_right ?driveSelectedStyle : driveStyle} 
          variant="contained">
            &#8600;
        </Button>
    	</Grid>
    </Grid>
  );
}

DriveButtons.propTypes = {
};
export default DriveButtons;
